import type { ReactNode } from "react";
import { Navigate, useNavigate } from "react-router";

import { usePermissions } from "../auth/permissions.ts";
import { Timeline } from "./Timeline.tsx";
import { TradeModal } from "./TradeModal.tsx";

/**
 * `/trades/new` es la bitacora con el formulario encima, como en la plantilla:
 * un solo modal, no un asistente por pasos.
 *
 * Es una ruta y no un estado suelto para que el boton central de la barra
 * inferior, el enlace del sidebar y un enlace compartido lleven al mismo sitio,
 * y para que "atras" en el telefono cierre el formulario en vez de salir de la
 * aplicacion.
 */
export function NewTrade(): ReactNode {
  const navigate = useNavigate();
  const { canWriteTrades } = usePermissions();

  /* Un Mentor no registra operaciones, asi que aqui no se le abre un formulario
     que el servidor va a rechazar: se queda en la bitacora, que si puede leer.
     ESCONDER NO ES AUTORIZAR: el 403 lo pone la politica `TradeWriter`. */
  if (!canWriteTrades) {
    return <Navigate to="/trades" replace />;
  }

  return (
    <>
      <Timeline />
      <TradeModal onClose={() => navigate("/trades", { replace: true })} />
    </>
  );
}
